import { useEffect } from "react";

import {
  BillingLoadState,
  BillingStoreActions,
  BillingStoreState,
  useBillingStore,
} from "stores/BillingStore";

// -----------------------------------------------------------------------------

export function useBilling(): [BillingStoreState, BillingStoreActions] {
  const [billingStore, billingActions] = useBillingStore();

  //
  useEffect(() => {
    if (billingStore.state === BillingLoadState.Unknown) {
      billingActions.load();
    }
  }, [billingStore, billingActions]);

  //
  return [billingStore, billingActions];
}
